(function (scope) {
  "use strict";
  var TransformationModule = (scope.TransformationModule = function (
    node,
    transCallback,
    rotCallback,
    mouseUpCallback
  ) {
    this.transCallback = transCallback;
    this.rotCallback = rotCallback;
    this.mouseUpCallback = mouseUpCallback;
    this.node = node;
    this.viewer = node.viewer;
    this.center = node.center;
    this.size = node.size;
    this.sphere_rotation = {
      active: false,
      visible: false,
      hide: false,
      x_node: null, //axis x circle node
      y_node: null, //y
      z_node: null, //z
    };
    this.arrows_translation = {
      active: false,
      visible: false,
      hide: false,
      x_node: null,
      y_node: null,
      z_node: null,
    };
    this.oldZoom = this.viewer.getZoom();
    this.currentShift = 0;
  });

  TransformationModule.prototype.initialize = function () {
    var idCircle = Utils.uniqueString();
    this.viewer.loadModel(rotationCircleModel, idCircle);
    this.sphere_rotation.x_node = this.viewer.createNode(idCircle);
    this.sphere_rotation.y_node = this.viewer.createNode(idCircle);
    this.sphere_rotation.z_node = this.viewer.createNode(idCircle);
    this.sphere_rotation.z_node.addEventListener(
      "load",
      function () {
        this.viewer.clearStatusMessage();
        this.sphere_rotation.z_node.removeEventListener("load");
      }.bind(this)
    );
    this.sphere_rotation.x_node.setMaterial(
      "full_af24732_df24732_s000000_e000000_t000000_x10000_i1_l0"
    );
    this.sphere_rotation.y_node.setMaterial(
      "full_a71eb33_d71eb33_s000000_e000000_t000000_x10000_i1_l0"
    );
    this.sphere_rotation.z_node.setMaterial(
      "full_a3c78d8_d3c78d8_s000000_e000000_t000000_x10000_i1_l0"
    );
    this.sphere_rotation.x_node.setDrawMode(
      Sculpteo3DViewerSceneNode.DRAWMODE_FLAT |
        Sculpteo3DViewerSceneNode.DRAWMODE_NO_CUT
    ); //you can use also drawmode_on_top
    this.sphere_rotation.y_node.setDrawMode(
      Sculpteo3DViewerSceneNode.DRAWMODE_FLAT |
        Sculpteo3DViewerSceneNode.DRAWMODE_NO_CUT
    );
    this.sphere_rotation.z_node.setDrawMode(
      Sculpteo3DViewerSceneNode.DRAWMODE_FLAT |
        Sculpteo3DViewerSceneNode.DRAWMODE_NO_CUT
    );
    this.sphere_rotation.x_node.setInteractive(
      Sculpteo3DViewerSceneNode.INTERACTIVE_MOUSEENTER |
        Sculpteo3DViewerSceneNode.INTERACTIVE_MOUSELEAVE |
        Sculpteo3DViewerSceneNode.INTERACTIVE_MOUSEDOWN
    );
    this.sphere_rotation.y_node.setInteractive(
      Sculpteo3DViewerSceneNode.INTERACTIVE_MOUSEENTER |
        Sculpteo3DViewerSceneNode.INTERACTIVE_MOUSELEAVE |
        Sculpteo3DViewerSceneNode.INTERACTIVE_MOUSEDOWN
    );
    this.sphere_rotation.z_node.setInteractive(
      Sculpteo3DViewerSceneNode.INTERACTIVE_MOUSEENTER |
        Sculpteo3DViewerSceneNode.INTERACTIVE_MOUSELEAVE |
        Sculpteo3DViewerSceneNode.INTERACTIVE_MOUSEDOWN
    );
    var idArrowT = Utils.uniqueString();
    this.viewer.loadModel(translationArrowModel, idArrowT);
    this.arrows_translation.x_node = this.viewer.createNode(idArrowT);
    this.arrows_translation.y_node = this.viewer.createNode(idArrowT);
    this.arrows_translation.z_node = this.viewer.createNode(idArrowT);
    this.arrows_translation.z_node.addEventListener(
      "load",
      function () {
        this.viewer.clearStatusMessage();
        this.arrows_translation.z_node.removeEventListener("load");
      }.bind(this)
    );
    this.arrows_translation.x_node.setMaterial(
      "full_af24732_df24732_s000000_e000000_t000000_x10000_i1_l0"
    );
    this.arrows_translation.y_node.setMaterial(
      "full_a71eb33_d71eb33_s000000_e000000_t000000_x10000_i1_l0"
    );
    this.arrows_translation.z_node.setMaterial(
      "full_a3c78d8_d3c78d8_s000000_e000000_t000000_x10000_i1_l0"
    );
    this.arrows_translation.x_node.setDrawMode(
      Sculpteo3DViewerSceneNode.DRAWMODE_FLAT |
        Sculpteo3DViewerSceneNode.DRAWMODE_NO_CUT |
        Sculpteo3DViewerSceneNode.DRAWMODE_ON_TOP
    );
    this.arrows_translation.y_node.setDrawMode(
      Sculpteo3DViewerSceneNode.DRAWMODE_FLAT |
        Sculpteo3DViewerSceneNode.DRAWMODE_NO_CUT |
        Sculpteo3DViewerSceneNode.DRAWMODE_ON_TOP
    );
    this.arrows_translation.z_node.setDrawMode(
      Sculpteo3DViewerSceneNode.DRAWMODE_FLAT |
        Sculpteo3DViewerSceneNode.DRAWMODE_NO_CUT |
        Sculpteo3DViewerSceneNode.DRAWMODE_ON_TOP
    );
    this.arrows_translation.x_node.setInteractive(
      Sculpteo3DViewerSceneNode.INTERACTIVE_MOUSEENTER |
        Sculpteo3DViewerSceneNode.INTERACTIVE_MOUSELEAVE |
        Sculpteo3DViewerSceneNode.INTERACTIVE_MOUSEDOWN
    );
    this.arrows_translation.y_node.setInteractive(
      Sculpteo3DViewerSceneNode.INTERACTIVE_MOUSEENTER |
        Sculpteo3DViewerSceneNode.INTERACTIVE_MOUSELEAVE |
        Sculpteo3DViewerSceneNode.INTERACTIVE_MOUSEDOWN
    );
    this.arrows_translation.z_node.setInteractive(
      Sculpteo3DViewerSceneNode.INTERACTIVE_MOUSEENTER |
        Sculpteo3DViewerSceneNode.INTERACTIVE_MOUSELEAVE |
        Sculpteo3DViewerSceneNode.INTERACTIVE_MOUSEDOWN
    );
  };

  TransformationModule.prototype.activateRotation = function (
    node,
    center,
    size
  ) {
    if (this.sphere_rotation.active) {
      return;
    }
    if (node) {
      this.node = node;
      this.viewer = node.viewer;
      if (center) {
        this.center = center;
      } else {
        this.center = node.center;
      }
      if (size) {
        this.size = size;
      } else {
        this.size = node.size;
      }
    }
    this.sphere_rotation.active = true;
    this.oldZoom = this.viewer.getZoom();
    this.updateSphereRotationWithCurrentNode();
    //		this.viewer.bind('zoom', this.onSphereRotationZoom.bind(this));
    this.sphere_rotation.x_node.addEventListener(
      "mouseenter",
      this.onMouseEnter
    );
    this.sphere_rotation.x_node.addEventListener(
      "mouseleave",
      this.onMouseLeave
    );
    this.sphere_rotation.y_node.addEventListener(
      "mouseenter",
      this.onMouseEnter
    );
    this.sphere_rotation.y_node.addEventListener(
      "mouseleave",
      this.onMouseLeave
    );
    this.sphere_rotation.z_node.addEventListener(
      "mouseenter",
      this.onMouseEnter
    );
    this.sphere_rotation.z_node.addEventListener(
      "mouseleave",
      this.onMouseLeave
    );
    this.sphere_rotation.x_node.addEventListener(
      "mousedown",
      this.onSphereRotationMousedownX.bind(this)
    );
    this.sphere_rotation.y_node.addEventListener(
      "mousedown",
      this.onSphereRotationMousedownY.bind(this)
    );
    this.sphere_rotation.z_node.addEventListener(
      "mousedown",
      this.onSphereRotationMousedownZ.bind(this)
    );
  };

  TransformationModule.prototype.deactivateRotation = function () {
    if (!this.sphere_rotation.active) {
      return;
    }
    this.sphere_rotation.active = false;
    this.sphere_rotation.visible = false;
    if (this.sphere_rotation.x_node) {
      this.sphere_rotation.x_node.detach();
    }
    if (this.sphere_rotation.y_node) {
      this.sphere_rotation.y_node.detach();
    }
    if (this.sphere_rotation.z_node) {
      this.sphere_rotation.z_node.detach();
    }
    //		this.viewer.unbind('zoom');
    this.sphere_rotation.x_node.removeEventListener("mouseenter");
    this.sphere_rotation.x_node.removeEventListener("mouseleave");
    this.sphere_rotation.y_node.removeEventListener("mouseenter");
    this.sphere_rotation.y_node.removeEventListener("mouseleave");
    this.sphere_rotation.z_node.removeEventListener("mouseenter");
    this.sphere_rotation.z_node.removeEventListener("mouseleave");
    this.sphere_rotation.x_node.removeEventListener("mousedown");
    this.sphere_rotation.y_node.removeEventListener("mousedown");
    this.sphere_rotation.z_node.removeEventListener("mousedown");
  };

  TransformationModule.prototype.activateTranslation = function (
    node,
    center,
    size
  ) {
    if (this.arrows_translation.active) {
      return;
    }
    if (node) {
      this.node = node;
      this.viewer = node.viewer;
      if (center) {
        this.center = center;
      } else {
        this.center = node.center;
      }
      if (size) {
        this.size = size;
      } else {
        this.size = node.size;
      }
    }
    this.arrows_translation.active = true;
    this.oldZoom = this.viewer.getZoom();
    this.updateArrowsTranslationWithCurrentNode();
    //		this.viewer.bind('zoom', this.onArrowsTranslationZoom.bind(this));
    this.arrows_translation.x_node.addEventListener(
      "mouseenter",
      this.onMouseEnter
    );
    this.arrows_translation.x_node.addEventListener(
      "mouseleave",
      this.onMouseLeave
    );
    this.arrows_translation.y_node.addEventListener(
      "mouseenter",
      this.onMouseEnter
    );
    this.arrows_translation.y_node.addEventListener(
      "mouseleave",
      this.onMouseLeave
    );
    this.arrows_translation.z_node.addEventListener(
      "mouseenter",
      this.onMouseEnter
    );
    this.arrows_translation.z_node.addEventListener(
      "mouseleave",
      this.onMouseLeave
    );
    this.arrows_translation.x_node.addEventListener(
      "mousedown",
      this.onArrowsTranslationMousedownX.bind(this)
    );
    this.arrows_translation.y_node.addEventListener(
      "mousedown",
      this.onArrowsTranslationMousedownY.bind(this)
    );
    this.arrows_translation.z_node.addEventListener(
      "mousedown",
      this.onArrowsTranslationMousedownZ.bind(this)
    );
  };

  TransformationModule.prototype.deactivateTranslation = function () {
    if (!this.arrows_translation.active) {
      return;
    }
    this.arrows_translation.active = false;
    this.arrows_translation.visible = false;
    if (this.arrows_translation.x_node) {
      this.arrows_translation.x_node.detach();
    }
    if (this.arrows_translation.y_node) {
      this.arrows_translation.y_node.detach();
    }
    if (this.arrows_translation.z_node) {
      this.arrows_translation.z_node.detach();
    }
    //		this.viewer.unbind('zoom');
    this.arrows_translation.x_node.removeEventListener("mouseenter");
    this.arrows_translation.x_node.removeEventListener("mouseleave");
    this.arrows_translation.y_node.removeEventListener("mouseenter");
    this.arrows_translation.y_node.removeEventListener("mouseleave");
    this.arrows_translation.z_node.removeEventListener("mouseenter");
    this.arrows_translation.z_node.removeEventListener("mouseleave");
    this.arrows_translation.x_node.removeEventListener("mousedown");
    this.arrows_translation.y_node.removeEventListener("mousedown");
    this.arrows_translation.z_node.removeEventListener("mousedown");
  };

  TransformationModule.prototype.deactivateAllTransformations = function () {
    this.deactivateRotation();
    this.deactivateTranslation();
  };

  TransformationModule.prototype.updateSphereRotationWithCurrentNode =
    function () {
      if (!this.sphere_rotation.active) {
        return;
      }
      var maxd = Math.max(this.size.x, this.size.y, this.size.z);
      var scale = maxd * Math.sqrt(2) * 0.5;
      var size = Math.max(this.size.x, this.size.y) * 0.5 * 1.5;
      var tr = [];
      for (var i = 0; i < 3; i++) {
        tr[i] = new Sculpteo3DViewerTransform3D();
        tr[i] = tr[i].scale(scale, scale, scale);
        switch (i) {
          case 0:
            tr[i] = tr[i].rotate(Math.PI / 2, 0, 1, 0);
            break;
          case 1:
            tr[i] = tr[i].rotate(Math.PI / 2, 1, 0, 0);
            break;
          case 2:
            tr[i] = tr[i].rotate(Math.PI / 2, 0, 0, 1);
            break;
        }
        tr[i] = tr[i].translate(this.center.x, this.center.y, this.center.z);
      }
      this.sphere_rotation.x_node.setTransform(tr[0]);
      this.sphere_rotation.y_node.setTransform(tr[1]);
      this.sphere_rotation.z_node.setTransform(tr[2]);
      if (!this.sphere_rotation.visible && !this.sphere_rotation.hide) {
        this.sphere_rotation.visible = true;
        var scene = this.viewer.getScene();
        scene.appendChild(this.sphere_rotation.x_node);
        scene.appendChild(this.sphere_rotation.y_node);
        scene.appendChild(this.sphere_rotation.z_node);
      }
    };

  TransformationModule.prototype.updateArrowsTranslationWithCurrentNode =
    function () {
      if (!this.arrows_translation.active) {
        return;
      }
      var maxd = Math.max(this.size.x, this.size.y, this.size.z);
      var scale = maxd * Math.sqrt(2) * 0.5;
      this.currentShift = scale * 0.5;
      var size = Math.max(this.size.x, this.size.y) * 0.5 * 1.5;
      var tr = [];
      for (var i = 0; i < 3; i++) {
        tr[i] = new Sculpteo3DViewerTransform3D();
        tr[i] = tr[i].scale(scale, scale, scale);
        switch (i) {
          case 0:
            tr[i] = tr[i].rotate(-Math.PI / 2, 0, 0, 1);
            break;
          case 1:
            break;
          case 2:
            tr[i] = tr[i].rotate(Math.PI / 2, 1, 0, 0);
            break;
        }
        tr[i] = tr[i].translate(this.center.x, this.center.y, this.center.z);
      }
      this.arrows_translation.x_node.setTransform(tr[0]);
      this.arrows_translation.y_node.setTransform(tr[1]);
      this.arrows_translation.z_node.setTransform(tr[2]);
      if (!this.arrows_translation.visible && !this.arrows_translation.hide) {
        this.arrows_translation.visible = true;
        var scene = this.viewer.getScene();
        scene.appendChild(this.arrows_translation.x_node);
        scene.appendChild(this.arrows_translation.y_node);
        scene.appendChild(this.arrows_translation.z_node);
      }
    };

  TransformationModule.prototype.onSphereRotationZoom = function () {
    var zoom = this.viewer.getZoom();
    var scale = zoom / this.oldZoom;
    this.oldZoom = zoom;
    var zoomTransform = Sculpteo3DViewerTransform3D.scale(scale, scale, scale);
    this.sphere_rotation.x_node.setTransform(
      this.sphere_rotation.x_node.transform.x(zoomTransform)
    );
    this.sphere_rotation.y_node.setTransform(
      this.sphere_rotation.y_node.transform.x(zoomTransform)
    );
    this.sphere_rotation.z_node.setTransform(
      this.sphere_rotation.z_node.transform.x(zoomTransform)
    );
  };

  TransformationModule.prototype.onArrowsTranslationZoom = function () {
    var zoom = this.viewer.getZoom();
    var scale = zoom / this.oldZoom;
    this.oldZoom = zoom;
    var zoomTransform = Sculpteo3DViewerTransform3D.scale(scale, scale, scale);
    var size =
      Math.max(this.size.x, this.size.y, this.size.z) * Math.sqrt(2) * 0.5;
    var shift = this.currentShift;
    if (scale < 1) {
      shift = -scale * shift * (1 / scale - 1);
      this.currentShift = this.currentShift * scale;
    } else if (scale > 1) {
      shift = shift * (scale - 1);
      this.currentShift = this.currentShift * scale;
    }
    var transformX = this.arrows_translation.x_node.transform
      .x(zoomTransform)
      .translate(shift, 0, 0);
    var transformY = this.arrows_translation.y_node.transform
      .x(zoomTransform)
      .translate(0, shift, 0);
    var transformZ = this.arrows_translation.z_node.transform
      .x(zoomTransform)
      .translate(0, 0, shift);
    this.arrows_translation.x_node.setTransform(transformX);
    this.arrows_translation.y_node.setTransform(transformY);
    this.arrows_translation.z_node.setTransform(transformZ);
  };

  TransformationModule.prototype.onSphereRotationMousedown = function (
    axis,
    rotCallback,
    mouseUpCallback,
    x,
    y,
    px,
    py,
    pz,
    dx,
    dy,
    dz
  ) {
    $(".Sculpteo3DViewerCommonLayer").removeClass("cursor-grab");
    $(".Sculpteo3DViewerCommonLayer").addClass("cursor-grabbing");
    var angle = 0;
    var totalTransform = Sculpteo3DViewerTransform3D.identity;
    var container = this.viewer.createUILayer({});
    var p = [0, 0, 0, 1];
    var updateContainer = function () {
      if (container.label) {
        container.label.detach();
      }
      var label = this.viewer.createUILabel({
        font: "arial",
        fontWeight: "bold",
        textHeight: 10,
        text: angle + "°",
        textColor: { r: 255, g: 255, b: 255, a: 255 },
        backgroundColor: { r: 0, g: 0, b: 0, a: 192 },
        borderColor: { r: 255, g: 255, b: 255, a: 255 },
        borderWidth: 1,
        borderRadius: 4,
      });
      label.setFrame(0, 20);
      container.label = label;
      container.appendChild(label);
      container.setFrame(0, 0, label.frame.w + 2, label.frame.h + 22);
      var P = this.viewer.getWorldToViewportTransform().x(p);
      container.setFrame(P[0], P[1]);
    }.bind(this);
    updateContainer();
    this.viewer.getRootLayer().appendChild(container);

    var incp = Math.sin(Math.PI / 12);
    var incn = -incp;
    var oldX = x;
    var oldY = y;
    var center = this.viewer
      .getWorldToViewportTransform()
      .x([this.center.x, this.center.y, this.center.z, 1]);
    var cX = center[0];
    var cY = center[1];
    var oldV = [oldX - cX, oldY - cY];
    var dOldV = Math.sqrt(oldV[0] * oldV[0] + oldV[1] * oldV[1]);
    oldV[0] = oldV[0] / dOldV;
    oldV[1] = oldV[1] / dOldV;
    var mouseMove = function (evt) {
      var curX = evt.pageX;
      var curY = evt.pageY;
      var curV = [curX - cX, curY - cY];
      var dCurV = Math.sqrt(curV[0] * curV[0] + curV[1] * curV[1]);
      curV[0] = curV[0] / dCurV;
      curV[1] = curV[1] / dCurV;
      var pv = oldV[0] * curV[1] - oldV[1] * curV[0];
      if (pv > incp) {
        var transform = new Sculpteo3DViewerTransform3D();
        transform = transform.translate(
          -this.center.x,
          -this.center.y,
          -this.center.z
        );
        switch (axis) {
          case "x":
            var rotq = Sculpteo3DViewerCommonTransform3D.eulerToQuat2(
              0,
              Math.sign(dx) * 15,
              0
            );
            angle = angle + Math.sign(dx) * 15;
            break;
          case "y":
            var rotq = Sculpteo3DViewerCommonTransform3D.eulerToQuat2(
              Math.sign(dy) * 15,
              0,
              0
            );
            angle = angle + Math.sign(dy) * 15;
            break;
          case "z":
            var rotq = Sculpteo3DViewerCommonTransform3D.eulerToQuat2(
              0,
              0,
              Math.sign(dz) * 15
            );
            angle = angle + Math.sign(dz) * 15;
            break;
          default:
            break;
        }
        transform = transform.rotateQ(rotq[0], rotq[1], rotq[2], rotq[3]);
        transform = transform.translate(
          this.center.x,
          this.center.y,
          this.center.z
        );
        var newTransform = transform.x(this.node.transform);
        switch (axis) {
          case "x":
            this.sphere_rotation.x_node.setTransform(
              transform.x(this.sphere_rotation.x_node.transform)
            );
            break;
          case "y":
            this.sphere_rotation.y_node.setTransform(
              transform.x(this.sphere_rotation.y_node.transform)
            );
            break;
          case "z":
            this.sphere_rotation.z_node.setTransform(
              transform.x(this.sphere_rotation.z_node.transform)
            );
            break;
          default:
            break;
        }
        this.node.setTransform(newTransform);
        updateContainer();
        rotCallback();
      } else if (pv < incn) {
        var transform = new Sculpteo3DViewerTransform3D();
        transform = transform.translate(
          -this.center.x,
          -this.center.y,
          -this.center.z
        );
        switch (axis) {
          case "x":
            var rotq = Sculpteo3DViewerCommonTransform3D.eulerToQuat2(
              0,
              -Math.sign(dx) * 15,
              0
            );
            angle = angle - Math.sign(dx) * 15;
            break;
          case "y":
            var rotq = Sculpteo3DViewerCommonTransform3D.eulerToQuat2(
              -Math.sign(dy) * 15,
              0,
              0
            );
            angle = angle - Math.sign(dy) * 15;
            break;
          case "z":
            var rotq = Sculpteo3DViewerCommonTransform3D.eulerToQuat2(
              0,
              0,
              -Math.sign(dz) * 15
            );
            angle = angle - Math.sign(dz) * 15;
            break;
          default:
            break;
        }
        transform = transform.rotateQ(rotq[0], rotq[1], rotq[2], rotq[3]);
        transform = transform.translate(
          this.center.x,
          this.center.y,
          this.center.z
        );
        var newTransform = transform.x(this.node.transform);
        switch (axis) {
          case "x":
            this.sphere_rotation.x_node.setTransform(
              transform.x(this.sphere_rotation.x_node.transform)
            );
            break;
          case "y":
            this.sphere_rotation.y_node.setTransform(
              transform.x(this.sphere_rotation.y_node.transform)
            );
            break;
          case "z":
            this.sphere_rotation.z_node.setTransform(
              transform.x(this.sphere_rotation.z_node.transform)
            );
            break;
          default:
            break;
        }
        this.node.setTransform(newTransform);
        updateContainer();
        rotCallback();
      } else {
        return;
      }
      oldX = curX;
      oldY = curY;
      oldV = curV;
    }.bind(this);
    var mouseUp = function () {
      $(".Sculpteo3DViewerCommonLayer").removeClass("cursor-grabbing");
      var rotqTinv; //Fix this: in nesting, rotation is inversed, use .inverse() somewhere in nesting.js and not -angle here
      switch (axis) {
        case "x":
          var rotqTinv = Sculpteo3DViewerCommonTransform3D.eulerToQuat2(
            0,
            -angle,
            0
          );
          break;
        case "y":
          var rotqTinv = Sculpteo3DViewerCommonTransform3D.eulerToQuat2(
            -angle,
            0,
            0
          );
          break;
        case "z":
          var rotqTinv = Sculpteo3DViewerCommonTransform3D.eulerToQuat2(
            0,
            0,
            -angle
          );
          break;
        default:
          break;
      }
      totalTransform = totalTransform.rotateQ(
        rotqTinv[0],
        rotqTinv[1],
        rotqTinv[2],
        rotqTinv[3]
      );
      mouseUpCallback(totalTransform);
      container.detach();
      $(".Sculpteo3DViewerCommonLayer").unbind("mousemove", mouseMove);
      $(".Sculpteo3DViewerCommonLayer").unbind("mouseup", mouseUp);
    };
    $(".Sculpteo3DViewerCommonLayer").bind("mousemove", mouseMove);
    $(".Sculpteo3DViewerCommonLayer").bind("mouseup", mouseUp);
  };

  TransformationModule.prototype.onArrowsTranslationMousedown = function (
    axis,
    transCallback,
    mouseUpCallback,
    x,
    y,
    px,
    py,
    pz,
    dx,
    dy,
    dz
  ) {
    $(".Sculpteo3DViewerCommonLayer").removeClass("cursor-grab");
    $(".Sculpteo3DViewerCommonLayer").addClass("cursor-grabbing");
    var translation = 0;
    var totalTransform = Sculpteo3DViewerTransform3D.identity;
    var container = this.viewer.createUILayer({});
    var p = [0, 0, 0, 1];
    var updateContainer = function () {
      if (container.label) {
        container.label.detach();
      }
      var label = this.viewer.createUILabel({
        font: "arial",
        fontWeight: "bold",
        textHeight: 10,
        text: translation.toFixed(2),
        textColor: { r: 255, g: 255, b: 255, a: 255 },
        backgroundColor: { r: 0, g: 0, b: 0, a: 192 },
        borderColor: { r: 255, g: 255, b: 255, a: 255 },
        borderWidth: 1,
        borderRadius: 4,
      });
      label.setFrame(0, 20);
      container.label = label;
      container.appendChild(label);
      container.setFrame(0, 0, label.frame.w + 2, label.frame.h + 22);
      var P = this.viewer.getWorldToViewportTransform().x(p);
      container.setFrame(P[0], P[1]);
    }.bind(this);
    updateContainer();
    this.viewer.getRootLayer().appendChild(container);

    var oldX = parseInt(x);
    var oldY = parseInt(y);
    var oldPoint = [oldX, oldY];

    var arrowPoint;
    switch (axis) {
      case "x":
        arrowPoint = this.arrows_translation.x_node.transform.x([0, 1, 0, 1]);
        break;
      case "y":
        arrowPoint = this.arrows_translation.y_node.transform.x([0, 1, 0, 1]);
        break;
      case "z":
        arrowPoint = this.arrows_translation.z_node.transform.x([0, 1, 0, 1]);
        break;
      default:
        break;
    }
    var center = [this.center.x, this.center.y, this.center.z, 1];
    var sizeArrow = Math.sqrt(
      (center[0] - arrowPoint[0]) * (center[0] - arrowPoint[0]) +
        (center[1] - arrowPoint[1]) * (center[1] - arrowPoint[1]) +
        (center[2] - arrowPoint[2]) * (center[2] - arrowPoint[2])
    );
    var p1 = this.viewer.getWorldToViewportTransform().x(arrowPoint);
    var p0 = this.viewer.getWorldToViewportTransform().x(center);
    var v = [p1[0] - p0[0], p1[1] - p0[1]];
    var d = Math.sqrt(v[0] * v[0] + v[1] * v[1]);
    //Don't break viewer if d is null (for example if arrow is perfectly aligned with camera axis)
    if (d == 0) {
      $(".Sculpteo3DViewerCommonLayer").removeClass("cursor-grabbing");
      container.detach();
      return;
    }
    v[0] = v[0] / d;
    v[1] = v[1] / d;
    var getOrtDis = function (x, y, xb, yb) {
      return (x - xb) * v[0] + (y - yb) * v[1];
    };
    var translationCoeff = sizeArrow / d;

    var mouseMove = function (evt) {
      var curX = parseInt(evt.pageX);
      var curY = parseInt(evt.pageY);
      var curPoint = [curX, curY];
      var value = getOrtDis(curPoint[0], curPoint[1], oldPoint[0], oldPoint[1]);
      var transform = new Sculpteo3DViewerTransform3D();
      var translationValue = value * translationCoeff;
      switch (axis) {
        case "x":
          var transform = transform.translate(translationValue, 0, 0);
          this.center.x = this.center.x + translationValue;
          break;
        case "y":
          var transform = transform.translate(0, translationValue, 0);
          this.center.y = this.center.y + translationValue;
          break;
        case "z":
          var transform = transform.translate(0, 0, translationValue);
          this.center.z = this.center.z + translationValue;
          break;
        default:
          break;
      }
      totalTransform = transform.x(totalTransform);
      var newTransform = transform.x(this.node.transform);
      this.node.setTransform(newTransform);
      this.arrows_translation.x_node.setTransform(
        transform.x(this.arrows_translation.x_node.transform)
      );
      this.arrows_translation.y_node.setTransform(
        transform.x(this.arrows_translation.y_node.transform)
      );
      this.arrows_translation.z_node.setTransform(
        transform.x(this.arrows_translation.z_node.transform)
      );
      translation = translation + translationValue;
      updateContainer();
      oldPoint = curPoint;
      transCallback();
    }.bind(this);
    var mouseUp = function () {
      $(".Sculpteo3DViewerCommonLayer").removeClass("cursor-grabbing");
      mouseUpCallback(totalTransform);
      container.detach();
      $(".Sculpteo3DViewerCommonLayer").unbind("mousemove", mouseMove);
      $(".Sculpteo3DViewerCommonLayer").unbind("mouseup", mouseUp);
    };
    $(".Sculpteo3DViewerCommonLayer").bind("mousemove", mouseMove);
    $(".Sculpteo3DViewerCommonLayer").bind("mouseup", mouseUp);
  };

  TransformationModule.prototype.onSphereRotationMousedownX = function (
    x,
    y,
    px,
    py,
    pz,
    dx,
    dy,
    dz
  ) {
    this.onSphereRotationMousedown(
      "x",
      this.rotCallback,
      this.mouseUpCallback,
      x,
      y,
      px,
      py,
      pz,
      dx,
      dy,
      dz
    );
  };

  TransformationModule.prototype.onSphereRotationMousedownY = function (
    x,
    y,
    px,
    py,
    pz,
    dx,
    dy,
    dz
  ) {
    this.onSphereRotationMousedown(
      "y",
      this.rotCallback,
      this.mouseUpCallback,
      x,
      y,
      px,
      py,
      pz,
      dx,
      dy,
      dz
    );
  };

  TransformationModule.prototype.onSphereRotationMousedownZ = function (
    x,
    y,
    px,
    py,
    pz,
    dx,
    dy,
    dz
  ) {
    this.onSphereRotationMousedown(
      "z",
      this.rotCallback,
      this.mouseUpCallback,
      x,
      y,
      px,
      py,
      pz,
      dx,
      dy,
      dz
    );
  };

  TransformationModule.prototype.onArrowsTranslationMousedownX = function (
    x,
    y,
    px,
    py,
    pz,
    dx,
    dy,
    dz
  ) {
    this.onArrowsTranslationMousedown(
      "x",
      this.transCallback,
      this.mouseUpCallback,
      x,
      y,
      px,
      py,
      pz,
      dx,
      dy,
      dz
    );
  };

  TransformationModule.prototype.onArrowsTranslationMousedownY = function (
    x,
    y,
    px,
    py,
    pz,
    dx,
    dy,
    dz
  ) {
    this.onArrowsTranslationMousedown(
      "y",
      this.transCallback,
      this.mouseUpCallback,
      x,
      y,
      px,
      py,
      pz,
      dx,
      dy,
      dz
    );
  };

  TransformationModule.prototype.onArrowsTranslationMousedownZ = function (
    x,
    y,
    px,
    py,
    pz,
    dx,
    dy,
    dz
  ) {
    this.onArrowsTranslationMousedown(
      "z",
      this.transCallback,
      this.mouseUpCallback,
      x,
      y,
      px,
      py,
      pz,
      dx,
      dy,
      dz
    );
  };

  TransformationModule.prototype.onMouseEnter = function () {
    if (!$(".Sculpteo3DViewerCommonLayer").hasClass("cursor-grabbing")) {
      $(".Sculpteo3DViewerCommonLayer").addClass("cursor-grab");
    }
  };

  TransformationModule.prototype.onMouseLeave = function () {
    if (!$(".Sculpteo3DViewerCommonLayer").hasClass("cursor-grabbing")) {
      $(".Sculpteo3DViewerCommonLayer").removeClass("cursor-grab");
    }
  };
})(window);
